var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_vm.methodType == 'CALENDAR' ? _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Due (Date)",
      "label-for": "due-date"
    }
  }, [_c('b-form-input', {
    staticClass: "w-100",
    attrs: {
      "id": "due-date",
      "type": "date",
      "disabled": true,
      "required": ""
    },
    model: {
      value: _vm.dueDateLocal,
      callback: function callback($$v) {
        _vm.dueDateLocal = $$v;
      },
      expression: "dueDateLocal"
    }
  })], 1)], 1) : _vm._e(), _vm.methodType == 'COUNTER' ? _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "possible_maintenance_hours"
    }
  }, [_vm._v("Due Running Hours")]), _c('InputCurrency', {
    attrs: {
      "prepend": "",
      "append": "Hours",
      "id": "possible_maintenance_hours",
      "type": "number",
      "min": 0,
      "placeholder": "Masukkan RH",
      "disabled": ""
    },
    model: {
      value: _vm.form.process.possible_maintenance_hours,
      callback: function callback($$v) {
        _vm.$set(_vm.form.process, "possible_maintenance_hours", _vm._n($$v));
      },
      expression: "form.process.possible_maintenance_hours"
    }
  })], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Maintenance Date *",
      "label-for": "maintenance-date"
    }
  }, [_c('b-form-input', {
    staticClass: "w-100",
    attrs: {
      "id": "maintenance-date",
      "type": "date",
      "min": _vm.minMaintenanceDate,
      "required": ""
    },
    model: {
      value: _vm.form.process.maintenance_date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.process, "maintenance_date", $$v);
      },
      expression: "form.process.maintenance_date"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cost"
    }
  }, [_c('b-input-group', [_c('b-input-group-prepend', [_c('b-input-group-text', [_vm._v("Rp")])], 1), _c('b-form-input', {
    attrs: {
      "placeholder": "0"
    },
    on: {
      "input": _vm.onCostInput
    },
    model: {
      value: _vm.costInput,
      callback: function callback($$v) {
        _vm.costInput = $$v;
      },
      expression: "costInput"
    }
  })], 1)], 1)], 1), _vm.methodType == 'COUNTER' ? [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "maintenance-running-hours"
    }
  }, [_vm.form.process.maintenance_date ? _c('i', {
    staticClass: "fas fa-exclamation-circle text-danger mr-1",
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "id": "actual-rh-warning"
    }
  }) : _vm._e(), _vm.form.process.maintenance_date ? _c('b-tooltip', {
    attrs: {
      "target": "actual-rh-warning",
      "placement": "top"
    }
  }, [_vm._v(" The data is actual, reference from feature "), _c('span', {
    staticClass: "text-warning cursor-pointer",
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.goToRunningHours
    }
  }, [_vm._v(" Running Hours ")])]) : _vm._e(), _vm._v(" Actual Rh ")], 1), _c('InputCurrency', {
    attrs: {
      "prepend": "",
      "id": "maintenance-running-hours",
      "append": "Hours",
      "type": "number",
      "min": 0,
      "placeholder": "0.00",
      "disabled": ""
    },
    model: {
      value: _vm.form.process.actual_running_hours,
      callback: function callback($$v) {
        _vm.$set(_vm.form.process, "actual_running_hours", _vm._n($$v));
      },
      expression: "form.process.actual_running_hours"
    }
  })], 1), _c('b-col', {
    staticClass: "pl-0",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "maintenance-running-hours"
    }
  }, [_vm._v(" Input RH "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('InputCurrency', {
    attrs: {
      "prepend": "",
      "id": "maintenance-running-hours",
      "append": "Hours",
      "type": "number",
      "min": 0,
      "placeholder": "0.00"
    },
    model: {
      value: _vm.form.process.maintenance_running_hours,
      callback: function callback($$v) {
        _vm.$set(_vm.form.process, "maintenance_running_hours", _vm._n($$v));
      },
      expression: "form.process.maintenance_running_hours"
    }
  })], 1)] : _vm._e()], 2), _c('b-form-group', {
    attrs: {
      "label": "Maintenance File"
    }
  }, [_c('input', {
    ref: "maintenanceFileInput",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.onFilesSelected
    }
  }), _c('b-button', {
    staticClass: "w-100",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.openFilePicker
    }
  }, [_c('i', {
    staticClass: "fas fa-plus mr-1"
  }), _vm._v(" Add Attachment ")]), _c('div', {
    staticClass: "mt-2"
  }, [_vm._l(_vm.existingAttachments, function (f, idx) {
    return _c('b-badge', {
      key: "existing-f-".concat(idx),
      staticClass: "mr-2 align-middle mb-2 cursor-pointer",
      attrs: {
        "variant": "warning",
        "pill": ""
      },
      on: {
        "click": function click($event) {
          return _vm.onPreview(f.fileurl);
        }
      }
    }, [_vm._v(" " + _vm._s(f.filename || f.name || 'attachment') + " "), _c('b-button', {
      staticClass: "p-0 ml-1",
      attrs: {
        "size": "xs",
        "variant": "link"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.removeExistingFile(idx);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-close mr-1"
    })])], 1);
  }), _vm._l(_vm.files, function (f, idx) {
    return _c('b-badge', {
      key: "f-".concat(idx),
      staticClass: "mr-2 align-middle mb-2 cursor-pointer",
      attrs: {
        "variant": "warning",
        "pill": ""
      },
      on: {
        "click": function click($event) {
          return _vm.previewLocalFile(f);
        }
      }
    }, [_vm._v(" " + _vm._s(f.name) + " "), _c('b-button', {
      staticClass: "p-0 ml-1",
      attrs: {
        "size": "xs",
        "variant": "link"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.removeFile(idx);
        }
      }
    }, [_vm._v(" × ")])], 1);
  })], 2), _c('small', {
    staticClass: "text-muted d-block mt-1"
  }, [_vm._v(" File Type: .pdf .xls .xlsx .doc .docx .jpg .jpeg .png — Max File Size: 2 MB ")])], 1), _c('b-form-group', {
    attrs: {
      "label": "Notes"
    }
  }, [_c('wysiwyg', {
    style: {
      minHeight: '200px'
    },
    attrs: {
      "placeholder": "Describe job here..."
    },
    model: {
      value: _vm.form.process.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.form.process, "notes", $$v);
      },
      expression: "form.process.notes"
    }
  })], 1), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Sign * : "), _c('strong', {
    staticClass: "text-black"
  }, [_vm._v("Mandatory (Must Fill)")])]), _c('div', {
    staticClass: "w-100 d-flex align-items-center justify-content-between mt-4"
  }, [_c('div', {
    staticClass: "ml-auto d-flex w-100"
  }, [_c('b-button', {
    staticClass: "mr-2 w-50",
    attrs: {
      "variant": "outline-secondary",
      "disabled": _vm.loading
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" Cancel & Close ")]), _c('b-button', {
    staticClass: "w-50",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.loading
    }
  }, [_vm.loading ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Submit ")], 1)], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }